export default __webpack_public_path__ + "static/media/1088.d202c280.png";